module.exports = __webpack_public_path__ + "img/icono-vacuna-circular.32fddd04.png";